export const BOOK_TYPE_ID = {
	EDUCATION: 1,
	FICTION: 2,
};
